import { render, staticRenderFns } from "./AdminSingleImageUpload.vue?vue&type=template&id=46875e47&scoped=true"
import script from "./AdminSingleImageUpload.vue?vue&type=script&lang=js"
export * from "./AdminSingleImageUpload.vue?vue&type=script&lang=js"
import style0 from "./AdminSingleImageUpload.vue?vue&type=style&index=0&id=46875e47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46875e47",
  null
  
)

export default component.exports